import type React from 'react'

interface CropIconProps {
  size?: number | string
  color?: string
  className?: string
}

const CropIcon: React.FC<CropIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Crop Icon'}
      role="img"
    >
      <path
        opacity="0.4"
        d="M13.6171 6.02539H7.69206C6.77539 6.02539 6.02539 6.77539 6.02539 7.69206V13.6171C6.02539 16.0254 7.97539 17.9754 10.3837 17.9754H16.3087C17.2254 17.9754 17.9754 17.2254 17.9754 16.3087V10.3837C17.9754 7.97539 16.0254 6.02539 13.6171 6.02539Z"
        fill={color}
      />
      <path
        d="M6.60768 3.66602C6.25768 3.66602 5.98268 3.94935 5.98268 4.29102V5.98268H4.29102C3.94935 5.98268 3.66602 6.25768 3.66602 6.60768C3.66602 6.95768 3.94935 7.23268 4.29102 7.23268H6.60768C6.94935 7.23268 7.23268 6.94935 7.23268 6.60768V4.29102C7.23268 3.94935 6.94935 3.66602 6.60768 3.66602Z"
        fill={color}
      />
      <path
        d="M19.7077 16.766H17.391C17.0493 16.766 16.766 17.0493 16.766 17.391V19.7077C16.766 20.0494 17.0493 20.3327 17.391 20.3327C17.7327 20.3327 18.016 20.0494 18.016 19.7077V18.016H19.7077C20.0494 18.016 20.3327 17.7327 20.3327 17.391C20.3327 17.0493 20.0494 16.766 19.7077 16.766Z"
        fill={color}
      />
    </svg>
  )
}

export default CropIcon
